<template>
  <RouterView />
  <Notification />
</template>
<script>
import { useStore } from 'vuex';
import { onMounted } from 'vue';
import Notification from '@/components/Common/Notifications/Main.vue';
import PersistentData from '@/plugins/persistentData';
import { useRoute } from 'vue-router';

export default {
  components: {
    Notification
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    if (route.name != "CustomerFacing") store.dispatch('manageUser_active');

    onMounted(async () => {
      try {
        const requestVersion = await store.dispatch("common_version");
        const versionStorage = PersistentData.get('web-v');
  
        if (versionStorage && versionStorage == requestVersion.data) return;
        PersistentData.set('web-v', requestVersion.data);
        location.reload(true);
      } catch (error) {
        console.error("Error get version ", error);
      }
    })
  }
}
</script>
<style lang="scss">
  @import '@/styles/_common.scss';
</style>
<style src="@vueform/multiselect/themes/default.css"></style>
<style lang="scss">
  .multiselect {
    background: none;
    border: none;
    border-radius: 4px;
    outline: none;
    min-width: 160px;
    width: 100%;
    background: #202020;

    &.is-active {
      border: none;
      box-shadow: none;
    }

    &.is-disabled {
      opacity: .5;
      background: none;
    }

    &-single-label {
      padding-left: 4px;
      padding-bottom: 4px;
    }

    &-placeholder {
      overflow: hidden;
      white-space: nowrap;
      max-width: 80%;
      text-overflow: ellipsis;
      color: #757575;
      padding-left: 4px;
      padding-bottom: 4px;
    }

    &-option {
      background: #202020;
      color: white;
      white-space: nowrap;

      &.is-selected, &.is-pointed, &.is-selected.is-pointed {
        background: #303030;
        color: white;

        &:hover {
          background: #303030;
          color: white;
        }
      }
      
      &:hover {
        background: #303030;
      }
    }

    &-dropdown {
      right: auto;
      min-width: 160px;
      width: fit-content;
      background: #202020;
      overflow-y: auto;
    }

    &-search {
      &:focus {
        border-color: none !important;
      }
    }

    &-clear {
      padding-bottom: 4px;
    }

    &-caret {
      margin-bottom: 4px;
    }
  }
</style>